/**
 * BrandGliderol.tsx — Gold Garage Door / Brand section · Gliderol
 * Standalone brand section (cream). Logo + SEO copy + common fixes + CTA.
 * MOBILE: real <style> media queries.
 * 10WEB AI: keep <img> + inline SVG + <style>. Wave dividers intentional — do NOT strip.
 */

const NAVY = "#081438";
const NAVY2 = "#0f2347";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const INK = "#1A1F2E";
const CREAM = "#FAF7F1";
const LOGO = "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/7656bc9c2_c348bc03e_gliderol-logo.webp";
const FIXES = ["Roller curtain repairs", "Spring & barrel servicing", "Gliderol motor faults", "Sectional panel repairs", "Track realignment", "Full door replacement"];

/** check — DO NOT REPLACE WITH IMG */
const Check = () => <svg data-icon-container="lucide-do-not-replace" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{
  flexShrink: 0,
  marginTop: "3px"
}}><polyline points="20 6 9 17 4 12" /></svg>;
export default function BrandGliderol() {
  return <section id="brand-gliderol" style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5rem",
    paddingBottom: "5rem"
  }}>
      <style>{`
        .br-grid { display: grid; grid-template-columns: 0.85fr 1.15fr; gap: 3rem; align-items: center; }
        .br-fixes { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem 1.25rem; }
        @media (max-width: 820px) {
          .br-grid { grid-template-columns: 1fr; gap: 1.75rem; }
          .br-fixes { grid-template-columns: 1fr; }
          #brand-gliderol { padding-top: 3.5rem; padding-bottom: 3.5rem; }
        }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.4,
      pointerEvents: "none",
      mixBlendMode: "multiply"
    }}><filter id="paper-brand-gliderol"><feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="5" stitchTiles="stitch" /><feColorMatrix type="matrix" values="0 0 0 0 0.85, 0 0 0 0 0.82, 0 0 0 0 0.74, 0 0 0 0.08 0" /></filter><rect width="100%" height="100%" filter="url(#paper-brand-gliderol)" /></svg>
      
      <div aria-hidden style={{
      position: "absolute",
      top: "5rem",
      right: "2rem",
      width: "60px",
      height: "60px",
      borderTop: `2px solid ${GOLD}55`,
      borderRight: `2px solid ${GOLD}55`,
      pointerEvents: "none",
      zIndex: 1
    }} />

      <div className="br-grid" style={{
      maxWidth: "1100px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        {/* logo panel */}
        <div style={{
        background: "#fff",
        border: `1px solid ${GOLD}22`,
        borderRadius: "16px",
        padding: "2.5rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        minHeight: "200px",
        boxShadow: "0 8px 28px rgba(8,20,56,0.06)"
      }}>
          <img src={LOGO} alt="Gliderol garage doors and openers serviced by Gold Garage Door" width={180} height={60} loading="lazy" decoding="async" style={{
          maxHeight: "60px",
          maxWidth: "200px",
          width: "auto",
          objectFit: "contain",
          filter: "none"
        }} />
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.78rem",
          fontWeight: 700,
          color: GOLD_DARK,
          letterSpacing: "0.05em",
          textAlign: "center"
        }}>Roller & sectional specialists</span>
        </div>

        {/* copy */}
        <div>
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.16em",
          color: GOLD_DARK,
          textTransform: "uppercase"
        }}>Brand We Service</span>
          <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.5rem, 5vw, 2.1rem)",
          color: NAVY,
          lineHeight: 1.15,
          margin: "0.6rem 0 0.75rem"
        }}>Gliderol repairs & installs</h2>
          <p style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.98rem",
          color: INK,
          lineHeight: 1.7,
          marginBottom: "1.5rem"
        }}>Gliderol roller and sectional doors are built for Australian conditions. We repair Gliderol curtains, springs and motors, and replace worn units with correctly matched parts for a smooth, quiet door.</p>

          <div className="br-fixes" style={{
          marginBottom: "1.75rem"
        }}>
            {FIXES.map((fx, j) => <div key={j} style={{
            display: "flex",
            gap: "0.6rem",
            alignItems: "flex-start"
          }}>
                <Check />
                <span style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "0.9rem",
              color: INK,
              lineHeight: 1.4
            }}>{fx}</span>
              </div>)}
          </div>


          {/* Models we service — Current / Older (real model numbers for SEO) */}
          <div style={{
          background: "#fff",
          border: `1px solid ${GOLD}22`,
          borderRadius: "14px",
          padding: "1.5rem",
          marginBottom: "1.75rem"
        }}>
            <div style={{
            fontFamily: "'Manrope', sans-serif",
            fontSize: "0.72rem",
            fontWeight: 700,
            letterSpacing: "0.14em",
            color: GOLD_DARK,
            textTransform: "uppercase",
            marginBottom: "1rem"
          }}>Models We Service</div>
            <div style={{
            marginBottom: "1rem"
          }}>
              <div style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700,
              fontSize: "0.85rem",
              color: NAVY,
              marginBottom: "0.5rem"
            }}>Current range</div>
              <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "0.4rem"
            }}>
                {["Glidamatic GTS2000", "Glidamatic GTS", "Glidaroll roller", "Glidatilt"].map(mdl => <span key={mdl} style={{
                fontFamily: "'Manrope', sans-serif",
                fontSize: "0.78rem",
                fontWeight: 600,
                color: NAVY,
                background: "#fff",
                border: `1px solid ${GOLD}33`,
                borderRadius: "999px",
                padding: "0.3rem 0.7rem"
              }}>{mdl}</span>)}
              </div>
            </div>
            <div>
              <div style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700,
              fontSize: "0.85rem",
              color: GOLD_DARK,
              marginBottom: "0.5rem"
            }}>Older / legacy models</div>
              <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "0.4rem"
            }}>
                {["Glidamatic TM", "Roll-A-Glide", "GTS older series", "legacy curtain motors"].map(mdl => <span key={mdl} style={{
                fontFamily: "'Manrope', sans-serif",
                fontSize: "0.76rem",
                fontWeight: 500,
                color: INK,
                background: "#F0EBE0",
                borderRadius: "999px",
                padding: "0.28rem 0.65rem"
              }}>{mdl}</span>)}
              </div>
            </div>
          </div>

          <a href="tel:0485000933" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          padding: "0.875rem 1.75rem",
          background: `linear-gradient(135deg, ${GOLD}, #d4a017)`,
          color: NAVY,
          fontWeight: 700,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          borderRadius: "8px",
          textDecoration: "none",
          fontSize: "0.95rem",
          boxShadow: `0 4px 20px ${GOLD}35`
        }}> Book a Gliderol job — 0485 000 933</a>
        </div>
      </div>

      
      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>
    </section>;
}